import './FeedbackFormField.scss'

import React from 'react'

export const FeedbackFormField = ({ label, isRequired, children, className, errorMsg, dataTestId }) => {
  className = `FeedbackFormField FormField ${className || ''}`
  return (
    <fieldset className={className} data-testid={dataTestId || label}>
      {label && <label>{label}{isRequired && ' *'}</label>}
      {children}
      <div className="FeedbackFormField__error">
      {errorMsg && errorMsg.length > 0 && <span>{errorMsg}</span>}
      </div>
    </fieldset>
  )
}
